import { lazy } from "react";
import AddCharter from "./Flight/Add";
import AirCalendar from "./Flight/AirCalendar";
import BookingHistory from "./Flight/Booking";
import ChangeRequestList from "./Flight/ChangeRequest/ChangeReqList";
import CharterFlightList from "./Flight/List";
import TransactionHistory from "./Transaction-history/TransactionHistory";

const Dashboard = lazy(() => import("./Dashboard/Dashboard"));

const supplierRoutes = [
  {
    path: "/supplier/dashboard",
    element: <Dashboard />,
  },
  {
    path: "/supplier/flight/booking-history",
    element: <BookingHistory />,
  },
  {
    path: "/supplier/flight/list",
    element: <CharterFlightList />,
  },
  {
    path: "/supplier/flight/add",
    element: <AddCharter />,
  },
  {
    path: "/supplier/flight/air-calendar",
    element: <AirCalendar />,
  },
  {
    path: "/supplier/flight/change-request",
    element: <ChangeRequestList />,
  },
  {
    path: "/supplier/transaction-log",
    element: <TransactionHistory />,
  },
];

export default supplierRoutes;
